/**
 * Deployed HTTPS callable name for Engage Data Issues dispositions.
 */
export const CALLABLE_CRAWLER_FAILURE_APPLY_DISPOSITION =
  'callableCrawlerFailureApplyDisposition-applyDisposition';

export const CRAWLER_FAILURE_DISPOSITION_ADOPT_WEBSITE = 'adopt_website';
export const CRAWLER_FAILURE_DISPOSITION_ADOPT_SOCIAL = 'adopt_social';
export const CRAWLER_FAILURE_DISPOSITION_FLAG_OOB = 'flag_oob';
